import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const SHORTCUT_INVENTORY_ITEMS = gql`
  query sellerShortcutInventoryItems(
    $pagination: PaginationInput!
    $filters: InventoryItemFilterInput
  ) {
    inventoryItems(pagination: $pagination, filters: $filters) {
      product {
        id
        name
        category {
          id
          name
          order
        }
        variants {
          id
          name
          imageUrl
          group {
            id
            name
          }
        }
      }
      isAvailable
    }
  }
`

export const SHORTCUT_INVENTORY_ITEMS_KEY = 'useShortcutInventoryItems'

export const useShortcutInventoryItems = (variables, options) =>
  useQuery({
    queryKey: [SHORTCUT_INVENTORY_ITEMS_KEY, variables],
    queryFn: () => client.request(SHORTCUT_INVENTORY_ITEMS, variables),
    ...options,
  })
